import React from 'react';
import Spinner from '../../../../../../components/Spinner';

import './SessionHistory.scss';


class SessionHistory extends React.Component {
  constructor(props) {
    super(props);

    const HiddenStatus = ['0', '10', '15', '299', '444'];

    const Bundled = props.AdvisorSessions.listSessions.reduce((sum, ModuleInstance) => Object.assign({}, sum, {
      [ModuleInstance.module_instance_status.id]: [
        ...(sum[ModuleInstance.module_instance_status.id] || []),
        ModuleInstance,
      ]
    }), {})

    const CleansedBundle = Object.keys(Bundled).reduce((sum, Status) => {
      if (HiddenStatus.includes(Status) === false) {
        return Object.assign({}, sum, {
          [Status]: Bundled[Status],
        })
      }

      return sum;
    }, {});


    this.state = {
      Bundle: CleansedBundle,
    }
  }

  getScheduledTime(ModuleInstance) {
    console.log(ModuleInstance.scheduled_to);

    if (ModuleInstance.scheduled_to !== null) {
      return <p><b>Scheduled:</b> {(new Date(ModuleInstance.scheduled_to)).toLocaleString()}</p>
    }

    return null;
  }

  renderEntries(Entries) {
    return Entries.map((ModuleInstance, Index) => (
      <div className="Sessions__Entry" key={Index}>
        <div className="row">
          <div className="col">
            <h6>{ModuleInstance.module.module_name}</h6>
            <p><b>Student: </b>{ModuleInstance.student.first_name + ' ' + ModuleInstance.student.last_name}</p>
            {this.getScheduledTime(ModuleInstance)}
            {(ModuleInstance.module.description !== null) ? <p>{ModuleInstance.module.description}</p> : null}
          </div>
          <div className="col">
            <div className="clearfix">
              {/* <a className='btn negative' href={"/scheduler/reject/" + ModuleInstance.id} target="_blank">Reject</a> */}
            </div>
          </div>
        </div>
      </div>
    ))
  }

  renderSegment(Segment) {
    return (
      <div className="Segment" key={'Segment_' + Segment[0].module_instance_status.id}>
        <h5 className="SegmentTitle">{Segment[0].module_instance_status.name}</h5>
        {this.renderEntries(Segment)}
      </div>
    )
  }

  render() {
    return (
      <div className="container">
        <div className='Session__History'>
          <h2>Sessions</h2>
          <p className="description">Here is a list of your sessions with students by the current phase they are in</p>
          {Object.keys(this.state.Bundle).map(Segment => this.renderSegment(this.state.Bundle[Segment]))}
          {(this.props.AdvisorSessions.listSessions.filter(x => x.module_instance_status !== null).filter(x => x.module_instance_status.id === 22).length === 0 ? <h6 style={{ margin: '0' }}>You do not have any sessions yet.</h6> : null)}
        </div>
      </div>
    );
  }
}

export default SessionHistory;



// WEBPACK FOOTER //
// ./src/routes/scheduler/routes/SessionHistory/components/SessionHistory/index.js